module.exports = __webpack_public_path__ + "img/l-3.ecf8ac34.png";